<template>
  <form @submit="onSubmit">
    <div class="flex flex-row gap-2 mb-10 mt-6">
      <div class="w-full text-center">
        <Button
          icon="pi pi-envelope text-5xl"
          text
          severity="info"
          class="w-16 h-16 mb-2 hover:scale-[1.15] hover:drop-shadow-md focus:ring-0 hover:bg-transparent transition duration-200 ease-out"
          @click="setFieldValue('send1099s', !values.send1099s)"
        ></Button>
        <LabeledCheckbox name="send1099s" label="Send 1099s?" size="w-fit mx-auto" :switch="true" />
      </div>
      <div class="w-full text-center">
        <Button
          icon="pi pi-globe text-5xl"
          text
          severity="info"
          class="w-16 h-16 mb-2 hover:scale-[1.15] hover:drop-shadow-md focus:ring-0 hover:bg-transparent transition duration-200 ease-out"
          @click="setFieldValue('webAccountEnabled', !values.webAccountEnabled)"
        ></Button>
        <LabeledCheckbox name="webAccountEnabled" label="Enable web account" size="w-fit mx-auto" :switch="true" />
      </div>
      <div class="w-full text-center">
        <Button
          icon="pi pi-book text-5xl"
          text
          severity="warning"
          class="w-16 h-16 mb-2 hover:scale-[1.15] hover:drop-shadow-md focus:ring-0 hover:bg-transparent transition duration-200 ease-out"
          @click="setFieldValue('webAccountReadOnly', !values.webAccountReadOnly)"
        ></Button>
        <LabeledCheckbox name="webAccountReadOnly" label="Read only web account" size="w-fit mx-auto" :switch="true" />
      </div>
    </div>
    <slot name="navigation"> </slot>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import { type Entity } from "@/types/Entity";
import { z } from "zod";

const emit = defineEmits<{
  submitStep: [values: any];
}>();

interface Props {
  entity?: Entity;
  data: any;
  setValues?: boolean;
  mode: "Add" | "Edit" | "Copy";
}
const props = withDefaults(defineProps<Props>(), {
  setValues: false,
});

const initialValues: any = {};

if (props.entity) {
  initialValues.webAccountEnabled = props.entity.webAccountStatus === "ENABLED";
  initialValues.webAccountReadOnly = props.entity.webAccountReadOnly;
  initialValues.send1099s = props.entity.send1099s;
}

const { handleSubmit, setFieldValue, values } = useForm({
  validationSchema: toTypedSchema(
    z
      .object({
        webAccountEnabled: z.boolean().default(false),
        webAccountReadOnly: z.boolean().default(false),
        send1099s: z.boolean().default(false),
      })
      .refine((data) => !data.webAccountEnabled || props.data.email.length > 0, {
        message: "An email is required to be web enabled",
        path: ["webAccountEnabled"],
      })
  ),
  initialValues: initialValues,
  keepValuesOnUnmount: true,
});

if (props.setValues) {
  setFieldValue("webAccountEnabled", props.data.webAccountEnabled);
  setFieldValue("webAccountReadOnly", props.data.webAccountReadOnly);
  setFieldValue("send1099s", props.data.send1099s);
}

const onSubmit = handleSubmit((values: any): void => {
  emit("submitStep", values);
});
</script>
